"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _defineProperty2 = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _TableRow = _interopRequireDefault(require("@material-ui/core/TableRow"));
var _styles = require("@material-ui/core/styles");
var _excluded = ["classes", "options", "rowSelected", "onClick", "className", "isRowSelectable"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var defaultBodyRowStyles = function defaultBodyRowStyles(theme) {
  return {
    root: {
      // material v4
      '&.Mui-selected': {
        backgroundColor: theme.palette.action.selected
      },
      // material v3 workaround
      '&.mui-row-selected': {
        backgroundColor: theme.palette.action.selected
      }
    },
    hoverCursor: {
      cursor: 'pointer'
    },
    responsiveStacked: _defineProperty2({}, theme.breakpoints.down('sm'), {
      borderTop: 'solid 2px rgba(0, 0, 0, 0.15)',
      borderBottom: 'solid 2px rgba(0, 0, 0, 0.15)',
      padding: 0,
      margin: 0
    }),
    responsiveSimple: _defineProperty2({}, theme.breakpoints.down('xs'), {
      borderTop: 'solid 2px rgba(0, 0, 0, 0.15)',
      borderBottom: 'solid 2px rgba(0, 0, 0, 0.15)',
      padding: 0,
      margin: 0
    })
  };
};
var TableBodyRow = /*#__PURE__*/function (_react$default$Compon) {
  _inherits(TableBodyRow, _react$default$Compon);
  function TableBodyRow() {
    _classCallCheck(this, TableBodyRow);
    return _possibleConstructorReturn(this, _getPrototypeOf(TableBodyRow).apply(this, arguments));
  }
  _createClass(TableBodyRow, [{
    key: "render",
    value: function render() {
      var _ref;
      var _this$props = this.props,
        classes = _this$props.classes,
        options = _this$props.options,
        rowSelected = _this$props.rowSelected,
        onClick = _this$props.onClick,
        className = _this$props.className,
        isRowSelectable = _this$props.isRowSelectable,
        rest = _objectWithoutProperties(_this$props, _excluded);
      var methods = {};
      if (onClick) {
        methods.onClick = onClick;
      }
      return /*#__PURE__*/_react.default.createElement(_TableRow.default, _extends({
        hover: !!options.rowHover
      }, methods, {
        className: (0, _classnames.default)((_ref = {}, _defineProperty2(_ref, classes.root, true), _defineProperty2(_ref, classes.hover, options.rowHover), _defineProperty2(_ref, classes.hoverCursor, options.selectableRowsOnClick && isRowSelectable || options.expandableRowsOnClick), _defineProperty2(_ref, classes.responsiveSimple, options.responsive === 'simple'), _defineProperty2(_ref, classes.responsiveStacked, options.responsive === 'vertical' || options.responsive === 'stacked' || options.responsive === 'stackedFullWidth'), _defineProperty2(_ref, 'mui-row-selected', rowSelected), _ref), className),
        selected: rowSelected
      }, rest), this.props.children);
    }
  }]);
  return TableBodyRow;
}(_react.default.Component);
_defineProperty(TableBodyRow, "propTypes", {
  /** Options used to describe table */
  options: _propTypes.default.object.isRequired,
  /** Callback to execute when row is clicked */
  onClick: _propTypes.default.func,
  /** Current row selected or not */
  rowSelected: _propTypes.default.bool,
  /** Extend the style applied to components */
  classes: _propTypes.default.object
});
var _default = (0, _styles.withStyles)(defaultBodyRowStyles, {
  name: 'MUIDataTableBodyRow'
})(TableBodyRow);
exports.default = _default;